import $ from 'jquery';
import SidebarState from 'app/scripts/view-models/sidebar-state';
import { useEffect } from 'react';
import { events } from 'app/src/backbone_events_DO_NOT_USE';

function updatePinnedDrawer() {
  $('#trello-root').toggleClass(
    'body-pinned-drawer',
    SidebarState.getPinSidebar(),
  );
}

export const usePinnedBoardsMenu = () => {
  useEffect(() => {
    updatePinnedDrawer();
    events.listenTo(
      SidebarState,
      'change:pinBoardsListSidebar',
      updatePinnedDrawer,
    );

    return () => {
      events.stopListening(
        SidebarState,
        'change:pinBoardsListSidebar',
        updatePinnedDrawer,
      );
    };
  }, []);
};
